import type { Variants } from "framer-motion";
import type { ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useMemo } from "react";

import { useAnimation } from "../../animation";

export interface CollapsibleContentProps {
  isExpanded: boolean;
  children: ReactNode;
  className?: string;
}

export function CollapsibleContent({
  isExpanded,
  children,
  className,
}: CollapsibleContentProps) {
  const { getSpring, getExitSpring } = useAnimation();

  const variants = useMemo((): Variants => {
    const enterTransition = getSpring("instant");
    const exitTransition = getExitSpring("instant");

    return {
      collapsed: {
        height: 0,
        opacity: 0,
        scale: 0.96,
        transition: {
          height: enterTransition,
          opacity: exitTransition,
          scale: exitTransition,
        },
      },
      expanded: {
        height: "auto",
        opacity: 1,
        scale: 1,
        transition: enterTransition,
      },
    };
  }, [getSpring, getExitSpring]);

  return (
    <AnimatePresence initial={false}>
      {isExpanded && (
        <motion.div
          animate="expanded"
          className={className}
          exit="collapsed"
          initial="collapsed"
          style={{ overflow: "hidden", transformOrigin: "top" }}
          variants={variants}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
